var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25418 10.4875C8.39585 10.8292 8.6528 11 9.02503 11H15.0084C15.3806 11 15.6375 10.8292 15.7792 10.4875C15.9209 10.1458 15.8612 9.84444 15.6 9.58334L12.6 6.56666C12.5112 6.47776 12.4195 6.41665 12.325 6.38331C12.2306 6.34998 12.1278 6.33331 12.0167 6.33331C11.9056 6.33331 11.8028 6.34998 11.7084 6.38331C11.6139 6.41665 11.5223 6.47776 11.4334 6.56666L8.43336 9.58334C8.17224 9.84444 8.11252 10.1458 8.25418 10.4875ZM8.43336 14.4333L11.4167 17.4167C11.5056 17.5055 11.5973 17.5694 11.6917 17.6083C11.7861 17.6472 11.8889 17.6667 12 17.6667C12.1112 17.6667 12.2139 17.6472 12.3084 17.6083C12.4028 17.5694 12.4945 17.5055 12.5834 17.4167L15.5667 14.4333C15.8278 14.1722 15.8876 13.8708 15.7459 13.5292C15.6042 13.1875 15.3473 13.0167 14.975 13.0167H9.02503C8.6528 13.0167 8.39585 13.1875 8.25418 13.5292C8.11252 13.8708 8.17224 14.1722 8.43336 14.4333Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/Sort.1e34eb06807ed7ca9842d423709dcd98.svg";
export { ForwardRef as ReactComponent };